import React from 'react';

interface TextareaProps {
	name?: string;
	label: string;
	value?: string;
	maxLength?: number;
	onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

function Textarea({ value, label, name, maxLength, onChange }: TextareaProps) {
	const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		onChange && onChange(e);
	};
	return (
		<div className='textarea__wrapper'>
			<label className='visually-hidden' htmlFor={name}>
				{label}
			</label>
			<textarea
				id={name}
				className='textarea'
				name={name}
				placeholder={label}
				onChange={handleChange}
				maxLength={maxLength}
			></textarea>
			<span className='textarea__wrapper__caption'>
				{value ? value.length : 0}/{maxLength}
			</span>
		</div>
	);
}

export default Textarea;
